import Modal from "react-modal";
import { useState } from "react";
import "../styles/Modal.css";

Modal.setAppElement("#root");

const UserAddModal = ({ isOpen, onClose, onAddUser }) => {
    const [newUser, setNewUser] = useState({ email: "", password: "", roles: ["ROLE_USER","ROLE_ADMIN"] });

    const handleSubmit = (e) => {
        e.preventDefault();
        onAddUser(newUser);
        setNewUser({ email: "", password: "", roles: ["ROLE_USER","ROLE_ADMIN"] });
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} className="modal-content modal-content--sm" overlayClassName="modal-overlay">
            <div className="modal-header">
                <h2 className="modal-title">Add user</h2>
                <button className="modal-close" onClick={onClose}>×</button>
            </div>
            <form onSubmit={handleSubmit} className="modal-form">
                <input
                    type="email"
                    placeholder="Email"
                    value={newUser.email}
                    onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={newUser.password}
                    onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                    required
                />
                <button type="submit" className="modal-button">Create</button>
            </form>
        </Modal>
    );
};

export default UserAddModal;
